export const LeftRightArrowIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="102"
      height="103"
      viewBox="0 0 102 103"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_b_1810_2622)">
        <rect
          y="0.341797"
          width="102"
          height="102"
          rx="12.5446"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M48.8125 66.709H46.625V68.9052C46.6264 69.318 46.511 69.7227 46.2921 70.0727C46.0732 70.4226 45.7598 70.7035 45.3881 70.8828C45.0163 71.0622 44.6014 71.1327 44.1913 71.0862C43.7811 71.0398 43.3925 70.8782 43.0703 70.6202L32.1328 61.8374C31.8763 61.6312 31.6694 61.3701 31.5272 61.0733C31.385 60.7765 31.3111 60.4515 31.3111 60.1224C31.3111 59.7933 31.385 59.4684 31.5272 59.1716C31.6694 58.8748 31.8763 58.6136 32.1328 58.4074L43.0703 49.6268C43.3923 49.3679 43.781 49.2056 44.1914 49.1587C44.6019 49.1117 45.0172 49.1821 45.3893 49.3616C45.7614 49.5411 46.075 49.8224 46.2937 50.1729C46.5124 50.5234 46.6273 50.9287 46.625 51.3418V53.538H48.8125V46.9515C48.8125 45.7374 49.7903 44.7552 51 44.7552H57.5625C58.7131 44.7552 59.6559 45.6477 59.7434 46.7787L64.9978 42.559L59.7434 38.3393C59.6559 39.4724 58.7153 40.3649 57.5625 40.3649H51C49.7903 40.3649 48.8125 39.3805 48.8125 38.1687V20.7168C32.9466 21.8499 20.375 35.1346 20.375 51.3418C20.375 67.549 32.9466 80.8337 48.8125 81.9668V66.709Z"
          fill="white"
        />
        <path
          d="M53.1875 20.7168V35.9746H55.375V33.7762C55.375 32.9318 55.8562 32.164 56.6131 31.7965C57.37 31.429 58.2712 31.534 58.9297 32.059L69.8672 40.8418C70.1241 41.048 70.3314 41.3093 70.4738 41.6063C70.6163 41.9033 70.6902 42.2285 70.6902 42.5579C70.6902 42.8873 70.6163 43.2125 70.4738 43.5095C70.3314 43.8065 70.1241 44.0678 69.8672 44.274L58.9297 53.0546C58.6083 53.3138 58.2198 53.4761 57.8096 53.5226C57.3993 53.5691 56.9843 53.4978 56.6131 53.3171C56.2423 53.137 55.9296 52.8564 55.7107 52.5071C55.4917 52.1578 55.3754 51.754 55.375 51.3418V49.1455H53.1875V55.7321C53.1875 56.9462 52.2097 57.9284 51 57.9284H44.4375C43.2869 57.9284 42.3441 57.0359 42.2566 55.9049L37 60.1246L42.2544 64.3421C42.3419 63.2112 43.2825 62.3187 44.4353 62.3187H50.9978C52.2075 62.3187 53.1853 63.303 53.1853 64.5149V81.9668C69.0513 80.8337 81.6228 67.549 81.6228 51.3418C81.6228 35.1346 69.0534 21.8499 53.1875 20.7168Z"
          fill="white"
        />
        <rect
          x="0.418153"
          y="0.75995"
          width="101.164"
          height="101.164"
          rx="12.1264"
          stroke="url(#paint0_linear_1810_2622)"
          strokeWidth="0.836306"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_1810_2622"
          x="-21.744"
          y="-21.4022"
          width="145.488"
          height="145.488"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="10.872" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1810_2622"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1810_2622"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1810_2622"
          x1="9.12934"
          y1="0.341796"
          x2="55.009"
          y2="62.2518"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
